<script>
  import { departmentProps, initValue } from '../index.js'

  export default {
    props: departmentProps,
    render () {
      const value = initValue(this.select)
      return <read-text { ...this.$props } value={ value }></read-text>
    }
  }
</script>